import { useStore } from "../components/ApartmentFinder/State/Store"
import {
  getNestedObject,
  getShapes,
  useApartmentBlockNameLevelByPlotNumber
} from "../components/ApartmentFinder/Utils/hooks"
import React, { useLayoutEffect, useRef } from "react"

export const BlockLabelIcon = ({ id }, props) => {
  const iconRef = useRef()
  const favourites = useStore(state => state.favourites)

  const blockIDs = useApartmentBlockNameLevelByPlotNumber()

  useLayoutEffect(() => {
    const blockIdName = getShapes(
      getNestedObject(iconRef.current.children, "dynamic_value")
    )
    const icon = getNestedObject(iconRef.current.children, "icon")

    //* BLOCK TITLE */
    blockIdName.map(c => (c.textContent = blockIDs[id].split(".")[0].charAt(0)))
    blockIdName.map(c => c.setAttribute("font-stretch", "condensed"))
    blockIdName.map(c => (c.style.fontStretch = "condensed"))

    //* Icon */
    icon.map(c => c.setAttribute("stroke-width", 17))
  }, [favourites])

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={iconRef}
      height="100%"
      viewBox="0 0 161.05 164.18"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="blockIcon">
          <g id="dynamic_element">
            <g id="text-type-1">
              <g id="dynamic_value">
                <text
                  transform="translate(49.82 121.13)"
                  fontSize="142.49"
                  fill="#3a1b52"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  D
                </text>
              </g>
            </g>
          </g>
          <g id="static_element">
            <g id="text-type-2">
              <text
                transform="translate(52.96 122.71) rotate(-90)"
                opacity="0.4"
                fontSize="18.55"
                fill="#3a1b52"
                fontFamily="NotoSans-Regular, Noto Sans"
              >
                B
                <tspan x="12.06" y="0" letter-spacing="-0.02em">
                  L
                </tspan>
                <tspan x="21.41" y="0">
                  OCK
                </tspan>
              </text>
            </g>
            <g id="icon-type-2">
              <path
                id="icon-type-2-2"
                data-name="icon-type-2"
                d="M134.78,90.34c0,33.19-27.09,60.09-60.52,60.09s-60.51-26.9-60.51-60.09S40.84,30.25,74.26,30.25"
                fill="none"
                stroke="#3a1b52"
                strokeMiterlimit="10"
                strokeWidth="27.49"
                opacity="0.4"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

// export default DynamicIcons
